import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-12" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col-lg-6 col-12" }
const _hoisted_6 = { class: "d-flex flex-row" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("h3", { class: "mb-0 mr-3" }, "Confirmation", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", null, "Show user inputs details", -1)
const _hoisted_9 = { class: "row w-100" }
const _hoisted_10 = { class: "col-md-12 col-lg-12 my-1" }
const _hoisted_11 = { class: "row mt-2 w-100" }
const _hoisted_12 = { class: "col-12 col-sm-8 col-md-8 col-lg-8 col-xl-10 my-1" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", { class: "text-muted h6 font-weight-normal mt-2" }, " Insert phone number without symbols (+, -, etc) or spaces ", -1)
const _hoisted_14 = { class: "col-12 col-sm-4 col-md-4 col-lg-4 col-xl-2 mt-2" }
const _hoisted_15 = {
  class: "btn-group",
  role: "group",
  "aria-label": "Basic example"
}
const _hoisted_16 = { class: "d-flex align-items-center" }
const _hoisted_17 = {
  key: 1,
  class: "fas fa-spinner fa-spin"
}
const _hoisted_18 = /*#__PURE__*/_createTextVNode(" Call ")

import { computed, ref } from "vue";
import { AlertModule } from "@/store/modules/Alert";
import { iInvalidSubmit } from "@/composables/vee-validate";
import { Form, FormActions, Field } from "vee-validate";
import { PhoneFilled, InfoFilled } from "@element-plus/icons";
import BaseInput from "@/components/Inputs/BaseInput.vue";
import Table from "@/components/TablePaginated.vue";
import { IColumn } from "@/types/components";
import { dialerApi } from "@/conection/index";
import * as yup from "yup";
import { IPagination } from "@/callcenter/omni";
import { ITablePagination } from "@/types/components";
import { IndexType } from "@/types/store";
import { DateTime } from "ts-luxon";
import { formatNumber } from "@/util/utils.ts";

interface iInputUser {
	id: number;
	phone_numer: number;
	input: string;
	text: string;
	playback: string;
	created_at: Date | string;
}
enum sendType {
	CALL = "call",
	SMS = "sms",
	WA = "wha",
}

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const formkey = ref(0);
const formComponent = ref<
	| (FormActions<any> & {
			getValues: () => { [k: string]: string | undefined };
	  })
	| null
>(null);
const loadingCall = ref(false);
const loadingTable = ref(false);

const pagination = {
	perPage: 6,
	currentPage: 1,
	perPageOptions: [6, 10, 25, 50],
	total: 0,
};
const model = ref({
	modal: false,
	pagination,
});
const td = ref<iInputUser[]>([]);
const th: IColumn[] = [
	{
		text: "Phone Number",
		value: "phone_number",
		width: 210,
	},
	{
		text: "Message",
		value: "text",
		width: 500,
	},
	{
		text: "User input",
		value: "input",
		width: 210,
	},
	{
		text: "Date",
		value: "created_at",
		width: 250,
	},
];
const paginate = ref<ITablePagination | undefined>({
	currentPage: 1,
	perPage: 5,
	perPageOptions: [5, 10, 15, 20],
	total: 0,
});
//schema
const schema = yup.object({
	message: yup
		.string()
		.matches(
			/^[\w\s\p{P}\p{S}]+$/u,
			"Message is not valid, It should not contain accents."
		)
		.required("Message is required"),
	number1: yup.string().matches(/^\d{3,}$/, "Phone number 1 is not valid"),
});
async function onSubmit(values: any, type: string) {
	switch (type) {
		case sendType.CALL:
			sendCall(values);
			break;

		default:
			break;
	}
}
async function sendCall(values: any) {
	loadingCall.value = true;
	try {
		const response = await dialerApi.post("/dialer/send/confirmation", {
			to: {
				number: formatNumber(values.number1),
				context: "llamada_saliente_internacional",
			},
			text: values.message,
			dtmf_options: {
				ttp: 5000,
				length: 2,
			},
			config: {
				repeat: 1,
				offsetms: 2000,
			},
		});
		if (response.status === 201) {
			AlertModule.SOCKET_PUSH_NOTIFICATION({
				text: `Call sent successfully`,
				type: "success",
			});
		} else {
			AlertModule.SOCKET_PUSH_NOTIFICATION({
				text: `Error// Call has not been sent`,
				type: "error",
			});
		}
	} catch (error) {
		AlertModule.SOCKET_PUSH_NOTIFICATION({
			text: `Error// Call has not been sent`,
			type: "error",
		});
	}

	loadingCall.value = false;
}
function onInvalidSubmit(values: iInvalidSubmit) {
	console.log(values);

	const errMsgs: string[] = Object.keys(values.errors);

	AlertModule.SOCKET_PUSH_NOTIFICATION({
		text: `Please Check ${errMsgs.join()}`,
		type: "error",
	});
}
async function fetchData(pag?: IPagination) {
	loadingTable.value = true;
	try {
		const response = await dialerApi.get<{
			count: number;
			rows: iInputUser[];
		}>("/call-input-user", {
			params: {
				page: pag?.page,
				limit: pag?.limit,
			},
		});
		td.value = response.data?.rows?.map(item => {
			const dateObject = DateTime.fromISO(item.created_at + "");
			return {
				...item,
				text: item.text.replace(/<[^>]*>/g, "").trim(),
				created_at: dateObject.toLocaleString(DateTime.DATETIME_FULL, {
					locale: "en-gb",
				}),
			};
		});

		paginate.value = {
			currentPage: Number(pag?.page),
			perPage: Number(pag?.limit),
			perPageOptions: [5, 10, 15, 20],
			total: response.data?.count,
		};
		if (response.status === 200) {
			AlertModule.SOCKET_PUSH_NOTIFICATION({
				text: `Get data`,
				type: "success",
			});
		} else {
			AlertModule.SOCKET_PUSH_NOTIFICATION({
				text: `Error// Get Data`,
				type: "error",
			});
		}
	} catch (error) {
		AlertModule.SOCKET_PUSH_NOTIFICATION({
			text: `Error// Cannot get data`,
			type: "error",
		});
	}

	loadingTable.value = false;
}

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_popover = _resolveComponent("el-popover")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_base_button = _resolveComponent("base-button")!
  const _component_card = _resolveComponent("card")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_card, { "header-classes": "bg-transparent" }, {
            header: _withCtx(() => [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _hoisted_7,
                    _createVNode(_component_el_popover, {
                      ref: "popoverRef",
                      placement: "top-start",
                      width: 200,
                      trigger: "hover",
                      "show-after": 10,
                      triggerKeys: []
                    }, {
                      default: _withCtx(() => [
                        _hoisted_8
                      ]),
                      reference: _withCtx(() => [
                        _createVNode(_component_el_button, {
                          onClick: _cache[0] || (_cache[0] = 
														() => {
															model.value.modal = true;
															fetchData({ page: 1, limit: 5 });
														}
													),
                          icon: _unref(InfoFilled),
                          size: "small",
                          circle: ""
                        }, null, 8, ["icon"])
                      ]),
                      _: 1
                    }, 512)
                  ])
                ])
              ])
            ]),
            default: _withCtx(() => [
              (_openBlock(), _createBlock(_unref(Form), {
                class: "w-100 form-inline",
                ref_key: "formComponent",
                ref: formComponent,
                key: formkey.value,
                "validation-schema": _unref(schema),
                onInvalidSubmit: onInvalidSubmit
              }, {
                default: _withCtx(({ handleSubmit, values }) => [
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("div", _hoisted_10, [
                      _createVNode(BaseInput, {
                        type: "textarea",
                        name: "message",
                        label: "Message",
                        placeholder: "",
                        "label-classes": "text-muted h5 font-weight-normal mr-3",
                        alternative: "",
                        inputGroupClasses: "w-75"
                      })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, [
                      _createVNode(BaseInput, {
                        name: "number1",
                        label: "Phone number 1",
                        placeholder: "22505555",
                        "label-classes": "text-muted h5 font-weight-normal mr-3",
                        "addon-left-icon": "fas fa-phone",
                        inputGroupClasses: "w-75",
                        alternative: ""
                      }, {
                        infoBlock: _withCtx(() => [
                          _hoisted_13
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("div", _hoisted_14, [
                      _createElementVNode("div", _hoisted_15, [
                        _createVNode(_component_base_button, {
                          disabled: loadingCall.value,
                          "native-type": "submit",
                          onClickCapture: ($event: any) => (
												handleSubmit($event, onSubmit(values, sendType.CALL))
											)
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_16, [
                              (!loadingCall.value)
                                ? (_openBlock(), _createBlock(_component_el_icon, {
                                    key: 0,
                                    size: 20,
                                    color: "#FFFFF",
                                    class: "no-inherit"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_unref(PhoneFilled))
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true),
                              (loadingCall.value)
                                ? (_openBlock(), _createElementBlock("i", _hoisted_17))
                                : _createCommentVNode("", true),
                              _hoisted_18
                            ])
                          ]),
                          _: 2
                        }, 1032, ["disabled", "onClickCapture"])
                      ])
                    ])
                  ])
                ]),
                _: 1
              }, 8, ["validation-schema"]))
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _createVNode(_component_el_dialog, {
      modelValue: model.value.modal,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((model.value.modal) = $event)),
      "show-close": false,
      width: "60%"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", null, [
          _createVNode(Table, {
            "card-class": "m--6 shadow-none rounded",
            tableData: { td: td.value, th: th, totalDocs: 0 },
            tittle: "Input User",
            tittlebtn: "Actualizar",
            load: loadingTable.value,
            disabled: false,
            btn: false,
            filter: false,
            pagination: paginate.value,
            onUpdateData: _cache[1] || (_cache[1] = ({ pagination }) => fetchData(pagination)),
            onUpdateInputData: _cache[2] || (_cache[2] = ({ pagination }) => fetchData(pagination)),
            tableLayout: "fixed"
          }, null, 8, ["tableData", "load", "pagination"])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})